import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import ProductItemListPageUI from './ProductItemListPageUI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class ProductItemListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      productItemList: null,
      createMode: false,
      customerList: null,
      updateMode: false,
      selectedInvoice: null,
      selectedProductItem: null,
      onUploadMode: false,
      uploadInvoiceSubmitted: false,
      uploadInvoiceSuccessMsg: null,
      uploadInvoiceErrorList: [],
    }
  }

  render() {
    return (
      <ProductItemListPageUI
        context={this.props.context}
        account={this.state.account}
        productItemList={this.state.productItemList}
        selectedInvoice={this.state.selectedInvoice}
        selectedProductItem={this.state.selectedProductItem}
        customerList={this.state.customerList}
        onRefreshClick={this.onRefreshClick}
        onDownloadClick={this.onDownloadClick}
        //
        createMode={this.state.createMode}
        onCreateClick={() => { this.setState({ createMode: true }) }}
        onCancelCreateItem={() => { this.setState({ createMode: false }) }}
        //
        updateMode={this.state.updateMode}
        onUpdateClick={this.onUpdateClick}
        onCancelClick={() => { this.setState({ updateMode: false }) }}

      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getProductItems(context)
  }

  onUpdateClick = (event) => {
    const productItemId = event.currentTarget.getAttribute('data-product-id');
    const selectedProductItem = this.state.productItemList.filter(item => item.productItemId === productItemId)[0];
    console.log(this.state.productItemList)
    console.log(productItemId)
    console.log(selectedProductItem)
    this.setState({ updateMode: true, selectedProductItem: selectedProductItem });
  }


  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getProductItems(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/productItems`,
      cacheKey: CacheKeys.ProductItems(this.props.match.params.accountId),
      callback: this.getProductItemsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getProductItemsCallback = (response) => {
    this.setState({
      productItemList: response.productItemList
    })
  }


  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.CustomerInvoices(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.Customers(this.props.match.params.accountId))
    this.setState({ productItemList: null },
      this.getProductItems(context)
    )
  }
}

export default withRouter(ProductItemListPageSF)



